import { atom } from "../editor-jotai";

/**
 * Shared open-state of the DrawLab Icon Picker, so both the App-level
 * keybinding handler (`/`) and the toolbar trigger can toggle it.
 */
export const drawLabIconPickerOpenAtom = atom<boolean>(false);

drawLabIconPickerOpenAtom.debugLabel = "drawLabIconPickerOpenAtom";
